module.exports = __webpack_public_path__ + "img/notifications-badge.eaf21273.png";